// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"e6889d3c","563":"f28ea54e","815":"d62b4755","834":"d692d534"}[chunkId] + ".chunk.js";
};